











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user'
import { getInstitutionInfos } from '@/utils/universal-variable'

@Component({
  name: 'resourceManagement',
})
export default class extends Vue {

  public institutionInfos: any[] = []

  get language() {
    return AppModule.language;
  }
  get onlineAgentUserId() {
    return UserModule.onlineAgentUserId;
  }
  get fkAgentId() {
    return UserModule.fkAgentId;
  }
  
  @Watch('language', { immediate: true })
  public onLanguageChange() {
    this.institutionInfos = getInstitutionInfos(this.language)
  }

  public getImageUrl(index: number) {
    try {
      return require(`@/assets/image/resource/icon_${index}.png`);
    } catch(err) {
      return '';
    }
  }

  public getApplyFee(subItem: any) {
    if ((subItem.countryId === undefined) || (subItem.countryId === null)) {
      window.open(subItem.link, "_blank")
    } else {
      this.$router.push({name: subItem.link, params: {id: subItem.countryId },query :{infoType: subItem.infoType }});
    }
  }
  public jumpForm() {
    window.open(
      `${process.env.VUE_APP_ISSUE_FORM_URL}?onlineAgentUserId=${this.onlineAgentUserId}&fkAgentId=${this.fkAgentId}`,
      '_blank'
    );
  }
}
